import {writable} from "svelte/store";

export const componentName = writable('');
export const form = writable({});
